// extracted by mini-css-extract-plugin
export default {"BetStatistics":"betStatistics_BetStatistics__YygAt","item":"betStatistics_item__zHpqO","title":"betStatistics_title__m2jRp","content":"betStatistics_content__5pj0X"};